var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDateFillGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.75C1.5 5.3355 1.5 4.629 1.9395 4.1895C2.379 3.75 3.0855 3.75 4.5 3.75H13.5C14.9145 3.75 15.621 3.75 16.0605 4.1895C16.5 4.629 16.5 5.3355 16.5 6.75C16.5 7.10325 16.5 7.28025 16.3905 7.3905C16.2802 7.5 16.1025 7.5 15.75 7.5H2.25C1.89675 7.5 1.71975 7.5 1.6095 7.3905C1.5 7.28025 1.5 7.1025 1.5 6.75ZM1.5 13.5C1.5 14.9145 1.5 15.621 1.9395 16.0605C2.379 16.5 3.0855 16.5 4.5 16.5H13.5C14.9145 16.5 15.621 16.5 16.0605 16.0605C16.5 15.621 16.5 14.9145 16.5 13.5V9.75C16.5 9.39675 16.5 9.21975 16.3905 9.1095C16.2802 9 16.1025 9 15.75 9H2.25C1.89675 9 1.71975 9 1.6095 9.1095C1.5 9.21975 1.5 9.3975 1.5 9.75V13.5Z",
    fill: "#8F96A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 2.25V4.5M12.75 2.25V4.5",
    stroke: "#8F96A9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDateFillGray);
export default __webpack_public_path__ + "static/media/ic_date_fill_gray.e8ac133f1a5aaad2e0f707f3ffc08234.svg";
export { ForwardRef as ReactComponent };